import events from 'events';
import AppDispatcher from './../dispatcher/AppDispatcher';
import AppConstants from './../constants/AppConstants';

const CHANGE_EVENT = 'change';
let _selectedCategory;
let _showOptions = false;
let _show = false;

const SortButtonStore = Object.assign({}, events.EventEmitter.prototype, {
  /**
   * Gets the current state
   * @returns {Object} The current state
   */
  getState() {
    return {
      selectedCategory: _selectedCategory,
      showOptions: _showOptions,
      show: _show,
    };
  },


  /**
   * Emits change event
   * @returns {undefined} undefined
   */
  emitChange() {
    this.emit(CHANGE_EVENT);
  },


  /**
   * Ads a listener function to the store
   * @param {Function} callback A function to add as a callback
   * @returns {undefined} undefined
   */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },


  /**
   * Removes a listener function from the store
   * @param {Function} callback A function to remove from the callbacks
   * @returns {undefined} undefined
   */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },


  /**
   * Listens for events and takes action accordingly
   * @returns {Boolean} true
   */
  dispatcherIndex: AppDispatcher.register(function registerCallback(payload) {
    const action = payload.action;

    switch (action.actionType) {
      case AppConstants.SET_CATEGORY:
        _selectedCategory = action.category;

        SortButtonStore.emitChange();
        break;

      case AppConstants.SHOW_CATEGORY_OPTIONS:
        _showOptions = true;

        SortButtonStore.emitChange();
        break;

      case AppConstants.HIDE_CATEGORY_OPTIONS:
        _showOptions = false;

        SortButtonStore.emitChange();
        break;

      case AppConstants.SHOW_TEAMS_SORT_BUTTON:
        _show = true;

        SortButtonStore.emitChange();
        break;

      default:
        break;
    }

    return true;
  }),
});

export default SortButtonStore;
